import { DialogBody } from "@blueprintjs/core";
import React from "react";

import { Button } from "../Button/button";
import { Modal } from "../modal/modal";
import styles from "./deleteTeamModal.module.css";

export interface DeleteTeamModalProps {
  show: boolean;
  handleClose: (e: any) => void;
  teamName: string;
  handleDeleteTeam: (e: any) => void;
}

const DeleteTeamModal = ({ show, handleClose, teamName, handleDeleteTeam }: DeleteTeamModalProps) => {
  return (
    <Modal
      title="Delete Team"
      isOpen={show}
      onClose={handleClose}
      actions={[
        <Button minimal={true} text="Cancel" onClick={handleClose} key={2} />,
        <Button intent="danger" text="Delete" onClick={handleDeleteTeam} key={1} />,
      ]}
    >
      <DialogBody>
        <div>
          Are you sure you want to delete team <div className={styles.teamName}>{teamName}</div>?
        </div>
      </DialogBody>
    </Modal>
  );
};

export default DeleteTeamModal;
